module.exports = __webpack_public_path__ + "img/4image-3.36072576.png";